import { Injectable } from '@angular/core';

import { AccountDetails } from '../models/AccountDetail';
import { Bill } from '../models/Bill';
import { WaterUsage } from '../models/WaterUsage';

let today = new Date();
let draft = new Date().setDate(today.getDate() + 15);
let start = new Date().setDate(today.getDate() - 30);

export const CURRENT_BILL: Bill = {
  draftDate: new Date(draft),
  periodStartDate: new Date(start),
  periodEndDate: today,
  total: 0.00,
  totalPGHUsed1Year: 0,
  totalGPHUsedLastMonth: 0,
  totalGPHUsedThisMonth: 0,
  AverageDailyCost1Year: 0.00,
  AverageDailyCostLastMonth: 0.00,
  AverageDailyCostThisMonth: 0.00,
  DaysInBillingPeriod1Year: 0,
  DaysInBillingPeriodLastMonth: 0,
  DaysInBillingPeriodThisMonth: 0
}

export const WATER_USAGE: WaterUsage[] = [
  { date: new Date('07/01/2017'), GPH: 0, dollars: 0 },
  { date: new Date('08/01/2017'), GPH: 0, dollars: 0 },
  { date: new Date('09/01/2017'), GPH: 0, dollars: 0 },
  { date: new Date('10/01/2017'), GPH: 0, dollars: 0 },
  { date: new Date('11/01/2017'), GPH: 0, dollars: 0 },
  { date: new Date('12/01/2017'), GPH: 0, dollars: 0 },
  { date: new Date('01/01/2018'), GPH: 0, dollars: 0 },
  { date: new Date('02/01/2018'), GPH: 0, dollars: 0 },
  { date: new Date('03/01/2018'), GPH: 0, dollars: 0 },
  { date: new Date('04/01/2018'), GPH: 0, dollars: 0 },
  { date: new Date('05/01/2018'), GPH: 0, dollars: 0 },
  { date: new Date('06/01/2018'), GPH: 0, dollars: 0 },
  { date: new Date('07/01/2018'), GPH: 0, dollars: 0 },
  { date: new Date('08/01/2018'), GPH: 0, dollars: 0 },
  { date: new Date('09/01/2018'), GPH: 0, dollars: 0 },
]

export class BillPayHistory {
  ID: number;
  BillDate: string;
  Description: string;
  Usage: string;
  Amount: string;
  Detail: Detail[];
}

export class Detail {
  PaymentMethod: string;
  BillingPeriod: string;
  AvgDailyUse: string;
  AvgDailyCost: string;
  Charges: string;
}

let history: BillPayHistory[] = [
  {
    ID: 1, BillDate: "10/18/2018", Description: "Payment", Usage: null, Amount: "$0.00",
    Detail: [{ PaymentMethod: "Direct Deposit", BillingPeriod: null, AvgDailyUse: null, AvgDailyCost: null, Charges: null }]
  },
  {
    ID: 2, BillDate: "10/04/2018", Description: "Bill", Usage: "0", Amount: "$0.00",
    Detail: [{ PaymentMethod: null, BillingPeriod: "N/A", AvgDailyUse: "N/A", AvgDailyCost: "$0.00", Charges: "$0.00" }]
    //Detail: [{ PaymentMethod: null, BillingPeriod: "29 Days - Sep 5 - Oct 4", AvgDailyUse: "96 gph", AvgDailyCost: "$10.13", Charges: "$293.79" }]
  },
  {
    ID: 3, BillDate: "09/19/2018", Description: "Payment", Usage: null, Amount: "$0.00",
    Detail: [{ PaymentMethod: "Direct Deposit", BillingPeriod: null, AvgDailyUse: null, AvgDailyCost: null, Charges: null }]
  },
  {
    ID: 4, BillDate: "09/05/2018", Description: "Bill", Usage: "0", Amount: "$0.00",
    Detail: [{ PaymentMethod: null, BillingPeriod: "N/A", AvgDailyUse: "N/A", AvgDailyCost: "$0.00", Charges: "$0.00" }]
  }
];

export class PowerUsage {
  date: string;
  dayType: string;
  usage: number;
  amount: number;
  cost: number;
  avgDaily: number;
  budget: number;
  type: string;
  computedReading: number;
}

export class Data {
  month: string;
  amount: number;
  usage: number;
}

let data: Data[] = [
  {
    month: "January",
    amount: 0,
    usage: 0
  }, {
    month: "February",
    amount: 0,
    usage: 0

  }, {
    month: "March",
    amount: 0,
    usage: 0
  }, {
    month: "April",
    amount: 0,
    usage: 0
  }, {
    month: "May",
    amount: 0,
    usage: 0
  }, {
    month: "June",
    amount: 0,
    usage: 0
  }, {
    month: "July",
    amount: 0,
    usage: 0
  }, {
    month: "August",
    amount: 100,
    usage: 0
  }, {
    month: "September",
    amount: 0.00,
    usage: 0
  }, {
    month: "October",
    amount: 0.00,
    usage: 0
  }];


@Injectable()
export class Service {
  getBillPayHistory() {
    return history;
  }
  getData(): Data[] {
    return data;
  }
}






// WEBPACK FOOTER //
// ./src/app/mock-data/mock-data.ts